<template>
  <div>
    <div class="read-guide-line" id="read-guide-line"></div>
    <div
        class="wacg-widget slideWacg"
        v-if="settings && settings.widgetStyle && settings.widgetStyle.positionType === '2'"
        :class="{hideWacg : dialog , 'wacg-rtl': isrtl }">

      <div class="widget-body">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title v-if="settings.widgetStyle">{{ $t('Accessibility Tools') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <div @click="dialog = !dialog" v-html="icons.close" style="margin-top: 20px"></div>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text style="padding: 12px 0px">
            <wacgBody :settings="settings" :features="settings.features"></wacgBody>
          </v-card-text>
        </v-card>
      </div>
      <v-btn class="btn-widget" :ripple="false" width="45" height="60" x-small dark color="primary"
             @click="dialog = !dialog">
        <div v-html="icons.iconCircle"></div>
      </v-btn>
    </div>
    <div class="wacg-widget " :class="{'wacg-rtl': isrtl, 'wacg-bubble-style': positionType === '3'}" v-else>
      <v-btn class="btn-widget mx-2" dark large color="primary" @click="dialog = !dialog" :fab="positionType ===  '3'">
        <span class="text-capitalize" v-if="positionType === '1'"> {{ $t('Accessibility Tools') }} </span>
        <div v-html="icons.iconCircle" style="margin: 4px"></div>
      </v-btn>
      <div class="widget-body" :class="{hide : !dialog}">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title v-if="settings.widgetStyle">{{ this.settings.widgetStyle.title }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <div @click="dialog = !dialog" v-html="icons.close" style="margin-top: 20px"></div>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="wacg-wrapper" style="padding: 0px">
            <wacgBody :settings="settings" :features="settings.features"></wacgBody>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-style v-if="settings.widgetStyle && settings.widgetStyle.positionRTL === 'LEFT'">

      .wacg-rtl .btn-widget {
      left: 5px !important;
      right: auto !important;
      }
      .wacg-rtl .widget-body {
      left: 14px !important;
      right: auto !important;
      }
    </v-style>
    <v-style v-if="settings.widgetStyle && settings.widgetStyle.position === 'RIGHT'">
      .btn-widget {
      right: 5px !important;
      left: auto !important;
      }
      .widget-body {
      right: 14px !important;
      left: auto !important;
      }
    </v-style>
    <v-style v-if="settings.widgetStyle && settings.widgetStyle.positionY === 'TOP'">
      .btn-widget {
      top: 20px;
      bottom: auto;
      }
      .widget-body {
      top: 70px;
      bottom: auto;
      }
    </v-style>
  </div>
</template>

<script>
import wacgBody from './wacg-body'
import {icons} from '../utils/icons'
import loadLang from "../utils/loadLang";

export default {
  name: "wacg-widget",
  components: {
    wacgBody
  },
  data() {
    return {
      icons,
      dialog: false,
      id: null,
      settings: {},
      voiceData: ''
    }
  },
  mounted() {
    this.getPluginSettings()
    let lang = this.$store.state.core.lang
    let newLang = lang
    setInterval(() => {
      newLang = loadLang.getLang()
      if (lang !== newLang) {
        this.$i18n.locale = newLang
        this.$vuetify.rtl = newLang === 'ar'
        this.$http.defaults.headers['Accept-Language'] = `${newLang}`
        this.$store.dispatch('setLang', newLang)
        lang = newLang
        this.getPluginSettings()
      }

    }, 3000);

  },
  methods: {
    getPluginSettings() {
      this.$http.get(`/customer-data?CUSTOMER_KEY=${this.userid}`)
          .then(response => {
            this.settings = response.data.response
            //this.settings.widgetStyle.positionType = '3'
            if (this.settings.widgetStyle.color) {
              this.$vuetify.theme.themes.light.primary = this.settings.widgetStyle.color.substring(0, this.settings.widgetStyle.color.length - 2);
            }
          })
          .catch(() => {

          })
    },
    updateLang(newLang) {
      this.$i18n.locale = newLang
      this.$vuetify.rtl = newLang === 'ar'
      this.$http.defaults.headers['Accept-Language'] = `${newLang}`
      this.$store.dispatch('setLang', newLang)
      //lang = newLang
      this.getPluginSettings()
    }
  },
  computed: {
    userid() {
      const divAttr = document.getElementById('wacg-wrapper')
      if (divAttr) {
        return divAttr.getAttribute('data-wacgid')
      } else {
        return null
      }
    },
    isrtl() {
      return this.$store.state.core.lang === 'ar'
    },
    windowPath() {
      return window.location.pathname
    },
    positionType() {
      return this.settings && this.settings.widgetStyle ? this.settings.widgetStyle.positionType : "1";
    }
  },
  watch: {
    'window.location.href': function () {

    }
  }
}
</script>

<style>
.widget-icon {
  width: 20px;
  height: 20px;
  margin: 0 7px;
}


</style>
